import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { SvgIconComponent } from 'angular-svg-icon';
import { ButtonComponent } from '../../../../aptem-component-library/components/button/button.component';
import { PageUtils } from '../../common/page.utils';
import { FixedContentPageComponent } from '../common/fixed-content/fixed-content.component';
import {AsyncPipe} from "@angular/common";
import {ContentComponent} from "../common/content/content.component";
import {Observable} from "rxjs";
import {selectCampaignContentByKey} from "../../store/selectors/campaign.selectors";
import {Store} from "@ngrx/store";
import {CampaignContentState} from "../../store/models/campaign-models";

@Component({
    selector: 'initiation',
    templateUrl: './initiation.component.html',
    styleUrls: ['./initiation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SvgIconComponent, ButtonComponent, FixedContentPageComponent, AsyncPipe, ContentComponent]
})
export class InitiationComponent {
  protected initiationIntroKey: string = 'initiation-page-intro';
  protected initiationIntroValue$: Observable<string | null>;

  constructor(
    private readonly router: Router,
    private readonly pageUtils: PageUtils,
    private readonly contentStore: Store<CampaignContentState>,
  ) {
    this.initiationIntroValue$ = this.contentStore.select(selectCampaignContentByKey(this.initiationIntroKey));
  }

  protected openAssessment(): void {
    const url = this.pageUtils.buildParameterisedRoute('introduction');
    this.router.navigateByUrl(url);
  }
}
